import * as React from "react";
import { DragPoints } from "../../../utils/dragAndDrop";
import { enableRefresh } from "../../../utils/jsBridge";

import SmallLoading from "../../components/SmallLoading";
import { RollOverContainer, RollOverBox } from "./styles.index";

interface SlideProductGroupProps {
	children?: any;
	isLoading: boolean;
	isValid?: boolean;
	gridGap?: number;
	parentGap?: number;
	onLoadMoreContent: () => void;
	handleSlideProduct?: (poolId: string, ids: string[]) => void;
	poolId?: string;
}
interface SlideProductGroupState {
	dragPoints: DragPoints | null;
}
class SlideProductGroup extends React.Component<SlideProductGroupProps, SlideProductGroupState> {
	private touchDiv: React.RefObject<HTMLDivElement> = React.createRef();
	touchEndTimer: NodeJS.Timeout;

	constructor(props: SlideProductGroupProps) {
		super(props);

		this.state = {
			dragPoints: null,
		};
	}
	get isDragging() {
		return this.state.dragPoints !== null;
	}
	componentDidMount() {
		window.addEventListener("touchend", this.onTouchEnd);
	}
	componentWillUnmount() {
		window.removeEventListener("touchend", this.onTouchEnd);
	}
	onTouchMove = (e: React.TouchEvent<HTMLDivElement>) => {
		if (!this.state.dragPoints?.startPoint) {
			return;
		}
		const { startPoint } = this.state.dragPoints;
		const touchTargetWrap = this.touchDiv?.current;
		const touchTarget = touchTargetWrap?.children[0];
		if (!touchTarget) {
			return;
		}
		const productsNum = touchTarget.children.length;
		const parentScrollLeft = touchTarget.scrollLeft;
		const middleProduct = touchTarget.children[productsNum - 1] as HTMLElement;
		const middleProductLeft = middleProduct ? middleProduct.offsetLeft / 2 : undefined;
		if (middleProductLeft !== undefined && parentScrollLeft >= middleProductLeft) {
			this.props.onLoadMoreContent();
		}
		if (this.isDragging) {
			const touch = e.touches[0];
			const endPoint = {
				x: touch.clientX,
				y: touch.clientY,
			};
			const a = Math.abs(endPoint.x - startPoint.x);
			const b = Math.abs(endPoint.y - startPoint.y);
			if (
				endPoint.y - startPoint.y > 0 &&
				Math.abs((Math.atan2(b, a) * 180) / Math.PI) >= 60
			) {
				enableRefresh({ refresh: true });
			}
		}
	};

	onTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
		const touch = e.touches[0];
		const dragPoints = {
			startPoint: {
				x: touch.clientX,
				y: touch.clientY,
			},
		};
		this.setState({ dragPoints });
		enableRefresh({ refresh: false });
	};

	onTouchEnd = () => {
		enableRefresh({ refresh: true });
		clearTimeout(this.touchEndTimer);
		this.touchEndTimer = setTimeout(this.onHandleTouchEndExport, 600);
	};

	// 计算元素是否在可视区域内
	onCalculateVisible = (
		parentScrollLeft: number,
		offsetWidthX: number,
		productNode: HTMLElement,
	) => {
		// 计算在可视区域内
		let visible = false;
		const productOffsetLeft = productNode.offsetLeft;
		const productOffseRight = productOffsetLeft + productNode.offsetWidth;
		const productLeftIn =
			productOffsetLeft >= parentScrollLeft && productOffsetLeft <= offsetWidthX;
		const productRightIn =
			productOffseRight >= parentScrollLeft && productOffseRight <= offsetWidthX;
		if (productLeftIn || productRightIn) {
			visible = true;
		}
		return visible;
	};

	onHandleTouchEndExport = () => {
		const { poolId } = this.props;
		if (this.touchDiv.current) {
			/** 获取产品横向滑动宽度 */
			const offsetWidth = this.touchDiv.current.offsetWidth;
			const touchTargetWrap = this.touchDiv?.current;
			const touchTarget = touchTargetWrap?.children[0];
			if(touchTarget) {
				/** 获取滚动区域左边滚动距离 */
				const parentScrollLeft = touchTarget.scrollLeft;
				/** 滚动区域滚动条到可视区域的x坐标 */
				const offsetWidthX = parentScrollLeft + offsetWidth;
				const children = touchTarget.children;
				// /** 记录需要曝光的产品 */
				const needExposureProducts: any[] = [];
				Object.values(children).forEach(item => {
					const product = item as HTMLElement;
					// 不需要完全展示才上报
					if (product && product.offsetWidth) {
						const visible = this.onCalculateVisible(parentScrollLeft, offsetWidthX, product);
						visible && needExposureProducts.push(product.id);
					}
	
				});
				poolId && this.props.handleSlideProduct && this.props.handleSlideProduct(poolId, needExposureProducts);
			}
		}
	};

	render() {
		const { isLoading, isValid = true, gridGap, parentGap } = this.props;
		return (
			<RollOverBox
				ref={this.touchDiv}
				onTouchMove={this.onTouchMove}
				onTouchStart={this.onTouchStart}
				onTouchEnd={this.onTouchEnd}
			>
				{isLoading || isValid ? (
					<RollOverContainer gridGap={gridGap} parentGap={parentGap}>
						{isLoading ? <SmallLoading /> : this.props.children}
					</RollOverContainer>
				) : null}
			</RollOverBox>
		);
	}
}

export default SlideProductGroup;
